import { UseFormRegisterReturn } from "react-hook-form";
import { twMerge } from "tailwind-merge";

import Label from "@/components/form-controls/Label";


export type TextInputProps = React.ComponentProps<"input"> & {
    label?: string,
    labelStyle?: string,
    inputStyle?: string,
    hasError?: boolean
    error? : string,
    register?: UseFormRegisterReturn;
    hint?: string
}


const TextInput = ({
    label, 
    labelStyle, 
    inputStyle,
    hasError, 
    error, 
    register, 
    prefix,
    hint,
    className,
    ...extra
}: TextInputProps) => {

    return (
        <div className={className}>
            <Label 
                name={extra.name ?? ""} 
                text={label} 
                required={extra.required}
                className={labelStyle}
                hint={hint}
            />

            <div className="relative">
                <input
                    type={extra.type}
                    className={twMerge(
                        "input", 
                        hasError ? "input-error" : "input-default",
                        prefix ? "pl-12" : "",
                        (extra.disabled || extra.readOnly) && "bg-primary-100",
                        inputStyle
                    )} 
                    placeholder={extra.placeholder}
                    {...register} 
                    {...extra}
                />

                {
                    error &&
                    <div className="text-xs text-rose-800 font-medium px-1 pt-1">
                        { error ? error : "field is required" }
                    </div>
                }
            </div>
            
        </div>
    )
}

export default TextInput